import React, { createContext, useEffect } from 'react';
import useLocalStorage from '../hooks/useLocalStorage';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const getDefaultLanguage = () => {
    try {
      const userLang = navigator.language || navigator.userLanguage;
      return userLang && userLang.toLowerCase().startsWith('tr') ? 'tr' : 'en';
    } catch (_) {
      return 'tr';
    }
  };

  const [language, setLanguage] = useLocalStorage('language', getDefaultLanguage());

  // Set <html lang="..."> for accessibility/SEO
  useEffect(() => {
    try {
      if (document?.documentElement) {
        document.documentElement.lang = language;
      }
    } catch (_) {}
  }, [language]);

  const translations = {
    tr: {
      heroTitle: "Yenilikçi Fikirler, Etkileyici Mobil Deneyimler",
      heroSubtitle: "Kullanıcı odaklı, yaratıcı ve yüksek performanslı mobil uygulamalar geliştiriyoruz. Teknoloji ve tasarımı bir araya getirerek, dijital dünyada fark yaratan deneyimler sunuyoruz.",
      contact: "İletişime Geç",
      ecommerce: "E-TİCARET",
      comingSoon: "YAKINDA",
      // Contact sayfası çevirileri
      contactPage: {
        title: "Bizimle <span>İletişime Geçin</span>",
        subtitle: "Sorularınız, önerileriniz veya işbirliği talepleriniz için bize ulaşın. Size en kısa sürede dönüş yapacağız.",
        address: "Fenerbahçe Mah. İğrip Sk. No: 13 İç Kapı No: 1, Kadıköy/İstanbul",
        form: {
          name: "İsim",
          namePlaceholder: "Adınız Soyadınız",
          email: "E-posta",
          emailPlaceholder: "ornek@email.com",
          message: "Mesaj",
          messagePlaceholder: "Mesajınızı buraya yazın...",
          submit: "Gönder"
        }
      },
      // Çarşıdan Al sayfası çevirileri
      carsidanAl: {
        title: "Çarşıdan AL",
        subtitle: "Yerel Alışverişin Dijital Adresi",
        description: "Çarşıdan AL, yerel satıcıları dijital dünyaya taşıyan ve kullanıcıların bulundukları şehirde ürün arayıp aynı gün temin edebilmelerini sağlayan yenilikçi bir alışveriş platformudur.",
        moreInfo: "Daha Fazla Bilgi",
        features: {
          delivery: {
            title: "Hızlı Teslimat",
            description: "Uzun kargo sürelerini beklemeden, ihtiyacınız olan ürüne aynı gün ulaşabilirsiniz."
          },
          local: {
            title: "Yerel Ekonomiye Katkı",
            description: "Bulunduğunuz şehirdeki işletmeleri destekler, yerel ekonomiyi canlandırırsınız."
          },
          cost: {
            title: "Düşük Maliyet",
            description: "Satıcılar yüksek komisyonlar yerine uygun abonelik ücretleriyle dijitale geçebilir."
          }
        },
        advantages: {
          sellers: {
            title: "Satıcılar İçin Avantajlar",
            items: [
              "Dijital Görünürlük: Mağazanızı çevrimiçi ortama taşıyarak müşteri kitlenizi büyütün.",
              "Kendi Fiyat Politikası: Ürün fiyatlarını ve stok bilgilerini özgürce belirleyin.",
              "Ek Gelir Modelleri: Öne çıkan vitrin, banner reklam gibi ek tanıtım araçları."
            ]
          },
          users: {
            title: "Kullanıcılar İçin Avantajlar",
            items: [
              "Zahmetsiz Fiyat Karşılaştırma: Şehrinizdeki fiyatlara tek tıkla ulaşın.",
              "Hızlı Teslimat: İhtiyacınız olan ürüne aynı gün içinde sahip olun.",
              "Yerel Destek: Alışverişlerinizle bölge ekonomisine katkı sağlayın."
            ]
          }
        },
        delivery: {
          title: "Esnek Teslimat Seçenekleri",
          options: {
            pickup: {
              title: "Mağazadan Alma",
              description: "Ürünü doğrudan kendiniz teslim alabilirsiniz."
            },
            seller: {
              title: "Satıcı Teslimatı",
              description: "Satıcı kendi imkanlarıyla ürünü kapınıza getirir."
            },
            platform: {
              title: "Platform Destekli Kargo",
              description: "Ek komisyon karşılığında aynı gün veya ertesi gün teslimat. (Yakında)"
            }
          }
        },
        contact: {
          title: "Bizimle <span>İletişime Geçin</span>",
          subtitle: "Sorularınız, önerileriniz veya işbirliği talepleriniz için bize ulaşın. Size en kısa sürede dönüş yapacağız.",
          address: "İstanbul, Türkiye",
          form: {
            name: "İsim",
            namePlaceholder: "Adınız Soyadınız",
            email: "E-posta",
            emailPlaceholder: "ornek@email.com",
            message: "Mesaj",
            messagePlaceholder: "Mesajınızı buraya yazın...",
            submit: "Gönder"
          }
        }
      },
      products: {
        carsidanAl: {
          tag: "FİYAT KARŞILAŞTIRMA",
          title: "Çarşıdan Al",
          description: "Yerel fiyat karşılaştırma platformu. Bulunduğunuz şehirdeki mağazaların fiyatlarını karşılaştırın, en uygun fiyatı bulun.",
          features: [
            "Yerel Fiyat Karşılaştırma",
            "Güvenli Alışveriş",
            "Satıcı Değerlendirmeleri",
            "Aynı Gün Teslimat"
          ]
        },

        paylasCozulsun: {
          tag: "YAKINDA",
          title: "Paylaş Çözülsün",
          pageTitle: "Sorunları Çözmek için",
          titleHighlight: "Harekete Geçin",
          description: "Çevrenizdeki sorunları paylaşın, ilgili kurumlara ulaştırın ve çözüm sürecini takip edin. Paylaş Çözülsün ile sorunları çözüme kavuşturmak artık çok kolay.",
          features: [
            "Sorun Paylaşımı",
            "Topluluk Çözümleri",
            "Oylama Sistemi",
            "Uzman Görüşleri",
            "İlerleme Takibi",
            "Etki Analizi"
          ],
          featureDetails: {
            sharing: {
              title: "Kolay Paylaşım",
              description: "Sorunu fotoğraflayın, konumu işaretleyin ve ilgili kurumları etiketleyin. Tek tıkla paylaşın."
            },
            targeting: {
              title: "Doğru Muhatap",
              description: "Sorunlar otomatik olarak sorumlu kurumlara iletilir. Çözüm sürecini şeffaf bir şekilde takip edin."
            },
            community: {
              title: "Topluluk Desteği",
              description: "Diğer kullanıcılar paylaşımınızı destekleyebilir, yorum yapabilir ve güncellemeleri takip edebilir."
            },
            progress: {
              title: "İlerleme Takibi",
              description: "Sorunun çözüm aşamalarını adım adım görün. Yetkililerin yanıtlarını ve yapılan işlemleri takip edin."
            }
          },
          posts: {
            post1: {
              location: "📍 Kadıköy, İstanbul",
              title: "Hasarlı Yol Zemini",
              description: "Rıhtım Caddesi üzerinde derin çukurlar oluştu. Araç trafiğini tehlikeye atıyor.",
              tags: ["@KadikoyBelediye", "@IbbYolBakim"]
            },
            post2: {
              location: "📍 Beşiktaş, İstanbul",
              title: "Bozuk Trafik Lambası",
              description: "Barbaros Bulvarı girişindeki trafik lambası 3 gündür çalışmıyor.",
              tags: ["@IbbTrafik", "@BesiktasBelediye"]
            }
          }
        }
      },
      footer: {
        copyright: `© ${new Date().getFullYear()} Creanity. Tüm hakları saklıdır.`
      },
      notFound: {
        title: "Sayfa Bulunamadı",
        description: "Aradığınız sayfa mevcut değil veya taşınmış olabilir.",
        button: "Ana Sayfaya Dön"
      }
    },
    en: {
      heroTitle: "Innovative Ideas, Impressive Mobile Experiences",
      heroSubtitle: "We develop user-centric, creative, and high-performance mobile applications. By combining technology and design, we deliver experiences that make a difference in the digital world.",
      contact: "Contact Us",
      ecommerce: "E-COMMERCE",
      comingSoon: "COMING SOON",
      // Contact sayfası çevirileri
      contactPage: {
        title: "Get in <span>Touch</span>",
        subtitle: "Contact us for your questions, suggestions, or collaboration requests. We'll get back to you as soon as possible.",
        address: "Istanbul, Turkey",
        form: {
          name: "Name",
          namePlaceholder: "Your Full Name",
          email: "Email",
          emailPlaceholder: "example@email.com",
          message: "Message",
          messagePlaceholder: "Write your message here...",
          submit: "Send"
        }
      },
      // Çarşıdan Al sayfası çevirileri
      carsidanAl: {
        title: "Çarşıdan AL",
        subtitle: "The Digital Address of Local Shopping",
        description: "Çarşıdan AL is an innovative shopping platform that brings local sellers to the digital world and enables users to search for and obtain products in their city on the same day.",
        moreInfo: "More Information",
        features: {
          delivery: {
            title: "Fast Delivery",
            description: "Get your needed products on the same day without waiting for long shipping times."
          },
          local: {
            title: "Support Local Economy",
            description: "Support businesses in your city and contribute to the local economy."
          },
          cost: {
            title: "Low Cost",
            description: "Sellers can go digital with affordable subscription fees instead of high commissions."
          }
        },
        advantages: {
          sellers: {
            title: "Advantages for Sellers",
            items: [
              "Digital Visibility: Expand your customer base by moving your store online.",
              "Own Pricing Policy: Set your product prices and stock information freely.",
              "Additional Revenue Models: Promotional tools like featured showcase and banner ads."
            ]
          },
          users: {
            title: "Advantages for Users",
            items: [
              "Effortless Price Comparison: Access prices in your city with one click.",
              "Fast Delivery: Get your needed products on the same day.",
              "Local Support: Contribute to the regional economy with your purchases."
            ]
          }
        },
        delivery: {
          title: "Flexible Delivery Options",
          options: {
            pickup: {
              title: "Store Pickup",
              description: "Pick up the product directly from the store."
            },
            seller: {
              title: "Seller Delivery",
              description: "The seller delivers the product to your door."
            },
            platform: {
              title: "Platform-Supported Shipping",
              description: "Same day or next day delivery for an additional commission. (Coming Soon)"
            }
          }
        },
        contact: {
          title: "Get in <span>Touch</span>",
          subtitle: "Contact us for your questions, suggestions, or collaboration requests. We'll get back to you as soon as possible.",
          address: "Fenerbahçe Mah. İğrip Sk. No: 13 İç Kapı No: 1, Kadıköy/İstanbul",
          form: {
            name: "Name",
            namePlaceholder: "Your Full Name",
            email: "Email",
            emailPlaceholder: "example@email.com",
            message: "Message",
            messagePlaceholder: "Write your message here...",
            submit: "Send"
          }
        }
      },
      products: {
        carsidanAl: {
          tag: "PRICE COMPARISON",
          title: "Çarşıdan Al",
          description: "Local price comparison platform. Compare prices from stores in your city and find the best deals.",
          features: [
            "Local Price Comparison",
            "Secure Shopping",
            "Seller Ratings",
            "Same Day Delivery"
          ]
        },

        paylasCozulsun: {
          tag: "COMING SOON",
          title: "Paylaş Çözülsün",
          pageTitle: "Take Action to",
          titleHighlight: "Solve Problems",
          description: "Share problems in your environment, forward them to relevant institutions, and track the solution process. With Paylaş Çözülsün, solving problems is now easy.",
          features: [
            "Problem Sharing",
            "Community Solutions",
            "Voting System",
            "Expert Opinions",
            "Progress Tracking",
            "Impact Analysis"
          ],
          featureDetails: {
            sharing: {
              title: "Easy Sharing",
              description: "Take a photo of the problem, mark the location, and tag relevant institutions. Share with one click."
            },
            targeting: {
              title: "Right Contact",
              description: "Problems are automatically forwarded to responsible institutions. Track the solution process transparently."
            },
            community: {
              title: "Community Support",
              description: "Other users can support your post, comment, and follow updates."
            },
            progress: {
              title: "Progress Tracking",
              description: "See the problem's solution stages step by step. Track responses from authorities and actions taken."
            }
          },
          posts: {
            post1: {
              location: "📍 Kadikoy, Istanbul",
              title: "Damaged Road Surface",
              description: "Deep potholes have formed on Rıhtım Street. Endangering vehicle traffic.",
              tags: ["@KadikoyMunicipality", "@IbbRoadMaint"]
            },
            post2: {
              location: "📍 Besiktas, Istanbul",
              title: "Broken Traffic Light",
              description: "The traffic light at the entrance of Barbaros Boulevard hasn't been working for 3 days.",
              tags: ["@IbbTraffic", "@BesiktasMunicipality"]
            }
          }
        }
      },
      footer: {
        copyright: `© ${new Date().getFullYear()} Creanity. All rights reserved.`
      },
      notFound: {
        title: "Page Not Found",
        description: "The page you are looking for doesn't exist or has been moved.",
        button: "Back to Home"
      }
    }
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, translations }}>
      {children}
    </LanguageContext.Provider>
  );
}; 